import d3 from 'd3';
import { vsprintf } from 'sprintf-js';

function format(number, round) {
    return formatNoSuffix(number, round) + 'B';
}

function formatDual(first, second, suffix) {
    const firstFormatter = d3.formatPrefix(first);
    const secondFormatter = d3.formatPrefix(second);

    const firstNumber = firstFormatter.scale(first);
    const secondNumber = secondFormatter.scale(second);
    const sameScale = firstFormatter.symbol == secondFormatter.symbol;
    const firstSuffix = sameScale ? '' : (firstFormatter.symbol + suffix);
    const secondSuffix = secondFormatter.symbol + suffix;

    return vsprintf('%s%s/%s%s', [firstNumber, firstSuffix, secondNumber, secondSuffix]);
}

function formatNoSuffix(number, round) {
    number = number || 0;

    var formatter = d3.formatPrefix(number);
    var formatted;

    if (round) {
        formatted = d3.round(formatter.scale(number), round);
    } else {
        formatted = formatter.scale(number);
    }

    return formatted + formatter.symbol;
}

export default { format, formatDual, formatNoSuffix };



// WEBPACK FOOTER //
// ./app/util/Bandwidth.js